import React, { memo, useEffect, useState } from 'react'
import ModalComponent from '../ModalComponent/Modal'
import { urlToBase64 } from '../../Functions/Utils'

function ShowImageComponent({ label, image, onLoad, ImgClass, bottomName }) {
  const [imagePreview, setImagePreview] = useState({ data: "", type: "", name: "" })
  const [visible, setVisible] = useState(false)
  const handlePreview = async (image) => {
    // const imageData = await urlToBase64(image)
    setImagePreview((pre) => ({ data: image, type: "img", name: label }))
    setVisible(true)
  }
  useEffect(() => {
    // //console.log(image)
  }, [image])

  const handleClose = () => {
    setVisible(false)
  }

  return (
    <>
      <div className="">
        <h2 className="font_16 fw-bold text-center mt-2 mb-2">
          {label}
        </h2>
      </div>

      <div className=" font_13">
        <div className="row">
          <div className='col-12'>

            <div className="bg_lightdark upload_thumb object_fit_contain w-100   p-1 br_15" >

              {image?.map((itm) => (
                // //console.log(itm),
                <img
                  onLoad={onLoad}
                  loading='lazy'
                  src={
                    itm}
                  onClick={() => handlePreview(itm)}
                  className={` object_fit_contain w-100 h-100  p-3`}
                />
              ))}

            </div>
          </div>
        </div>
        <ModalComponent show={visible} imgPreview={imagePreview} handleClose={handleClose} />
      </div>
    </>
  )
}

export default ShowImageComponent
